import React from "react";

// BuildRaq wordmark + node icon.
// Icon: three stacked server/node blades forming a subtle "B" rhythm,
// with an electric-azure connection dot.
export const Logo = ({ className = "", showWordmark = true, size = 28 }) => {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`} aria-label="BuildRaq">
      <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="shrink-0"
        aria-hidden="true"
      >
        <rect x="4" y="5" width="20" height="5.2" rx="1.6" fill="#F9FAFB" />
        <rect x="4" y="13.4" width="24" height="5.2" rx="1.6" fill="#F9FAFB" fillOpacity="0.55" />
        <rect x="4" y="21.8" width="16" height="5.2" rx="1.6" fill="#F9FAFB" fillOpacity="0.28" />
        <circle cx="26.4" cy="24.4" r="2.6" fill="#3B82F6" />
      </svg>
      {showWordmark && (
        <span className="font-heading font-semibold tracking-tight text-[1.15rem] leading-none text-white">
          Build<span className="font-light text-white/70">Raq</span>
        </span>
      )}
    </span>
  );
};

export default Logo;
